import { store } from '@/decorators/store';
import { Filter } from '@/entities/Filter';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'FilterStore' })
export class FilterStore extends AbstractEntityStore<Filter> {
  protected entityIdKey = 'id';
  protected entityLabelKey = 'name';
  protected entityValueKey = 'name';
}
